import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConventionRegistration } from 'app/models/convention-registration.model';
import { ProcessedEntityPaymentExtension } from 'app/models/extensions/processed-entity-payment-extension.model';
import { PaymentTransaction } from 'app/models/payment-transaction.model';
import { ProcessedEntity } from 'app/models/processed-entity.model';
import { MRMValidators } from '@mrm/core';

export class ProcessedEntityPayment extends ProcessedEntityPaymentExtension {
  processedEntityPaymentDBID: number = 0;
  processedEntityDBID: number = 0;
  paymentTransactionDBID: number = 0;
  conventionRegistrationDBID?: number = null;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  conventionRegistration: ConventionRegistration = null;
  paymentTransaction: PaymentTransaction = null;
  processedEntity: ProcessedEntity = null;

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      processedEntityPaymentDBID: new FormControl({ value: 0, disabled: disableAll }),
      processedEntityDBID: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      paymentTransactionDBID: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      conventionRegistrationDBID: new FormControl({ value: null, disabled: disableAll }),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),

    });

    // Only add navigational properties to the form when needed.
    // If navigational properties are included they MUST NOT be null when patching the form.
    if (includeNav.length > 0) {
      for (const key of includeNav) {
        switch (key.toLowerCase()) {
          case 'conventionregistration':
            form.addControl('conventionRegistration', ConventionRegistration.getForm(disableAll)); break;
          case 'paymenttransaction':
            form.addControl('paymentTransaction', PaymentTransaction.getForm(disableAll)); break;
          case 'processedentity':
            form.addControl('processedEntity', ProcessedEntity.getForm(disableAll)); break;
          default:
            // tslint:disable-next-line:max-line-length
            throw new Error(`'${key}' is not a property of ProcessedEntityPayment. Please use one of the following navigational property: 'conventionRegistration' | 'paymentTransaction' | 'processedEntity'`);
        }
      }
    }

    return form;
  }
}